import React, { useEffect, useState, Fragment } from 'react';
import Button from '../../Components/Button'
import './index.scss'
import Dialog from '../../Components/Dialog'
import {utilService, riskManagement} from '../../Utils/Utils/index'
import LightMobileCall from "@kugou/light-mobilecall";
import e from '../../Utils/Event'
import FaceRecognition from'../FaceRecognition'

let reqFlag = false;
let faceAuthReq = false;
let _reqId = '';
let toFaceAuth = false;

export default function ChangeAccountInput(props) {
  const [idNum, setIdNum] = useState('')
  const [name, setName] = useState('')
  //提示弹窗
  const [showTipsDialog, setShowTipsDialog] = useState(false)
  const [tipsContent, setTipsContent] = useState('')
  const [btnFn, setBtnFn] = useState(null)
  const [hideClose, setHideClose] = useState(false)
  const [singerId, setSingerId] = useState('')
  const [singerSource, setSingerSource] = useState('')
  const [jumpUrl, setJumpUrl] = useState('')
  const [reqId, setReqId] = useState('')
  const [openRecognite, setOpenRecognite] = useState('')
  //实名认证回来
  const [faceAuthBack, setFaceAuthBack] = useState('')

  //透传所有url参数
  let curUrl = "https://h5.kugou.com/apps/musician-enter/build/"

  function showTips(word, btnFn, hideClose) {
    setTipsContent(word)
    let fn = [{ text: '知道了', fn: () => {setShowTipsDialog(false);btnFn&&btnFn();} }];
    setBtnFn(btnFn || fn)
    setShowTipsDialog(true)
    setHideClose(hideClose)
  }

  function faceAuth(cb, errCb){
    if( !idNum ){
      return window.$Msg('请输入正确的身份证号')
    }
    if( !name ){
      return window.$Msg('请输入姓名')
    }
    // 检查身份证号码
    var reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
    if (reg.test(idNum) == false) {
      return window.$Msg('请输入正确的身份证号')
    }

    // 检查姓名
    if (utilService.trim(name) == "" || name == undefined) {
      return window.$Msg('请输入姓名')
    }

    let data = {
      idno: idNum,
      kugouid: window.$userInfo.userid
    }
    if(faceAuthReq){return;}
    faceAuthReq = true;
    e.emit('loading', true)
    window.$req('getFaceAuth', data).then(res => {
      faceAuthReq = false;
      e.emit('loading', false)
    }).catch(rese => {
      faceAuthReq = false;
      e.emit('loading', false)
      if(+rese.face_auth == 1){
        cb && cb();
      }else if(+rese.face_auth == 0){
        window.$Msg('该账号已有其他用户实名认证过，请换一个酷狗账号')
      }else{
        window.$Msg(rese.msg || rese.message || '网络异常，请稍后再试')
        errCb && errCb();
      }
    })
  }

  //实名认证绑定账号-校验
  function checkInfo(cb, errCb){
    let data = {
      name: name,
      idCardNum: idNum,
      singerId: singerId,
      singerSource: singerSource,
      platformAccountId: window.$userInfo.userid,
      platformIdType: 2
    }
    if(reqFlag){return;}
    reqFlag = true;
    e.emit('loading', true)
    window.$req('bindByRealPerson', data).then(res => {
      reqFlag = false;
      e.emit('loading', false)
      if(+res.code == 0){
        setReqId(res.data.reqId)
        _reqId = res.data.reqId
        cb && cb(res.data.reqId);
      }
    }).catch(rese => {
      reqFlag = false;
      e.emit('loading', false)
      if( rese.code == 100062 ){
        window.$Msg("该身份证号未检测有入驻记录")
      }else{
        window.$Msg(rese.msg || rese.message || '网络异常，请稍后再试')
      }
      errCb && errCb();
    })
  }
  //确认绑定账号接口
  function bindConfirm(rid){
    let data = {
      reqId:　rid || _reqId,
      platformAccountId: window.$userInfo.userid,
      platformIdType: 2
    }
    e.emit('loading', true)
    window.$req('bindPhoneConfirm', data).then(res => {
      e.emit('loading', false)
      if(+res.code == 0){
        showTips(`您已成功换绑酷狗id${window.$userInfo.userid}`,[{ text: '好的', fn: () => {
          setShowTipsDialog(false);
          window.location.href = curUrl;
        } }], true)
      }
    }).catch(rese => {
      e.emit('loading', false)
      if((rese.errcode === 20028 || rese.errcode === 20029) && window.rejectRes) {//触发风控
        riskManagement(window.rejectRes);
        return;
      }
      window.$Msg(rese.msg || rese.message || '网络异常，请稍后再试')
    })
  }

  function recognite(){
    window.pushBI({
      a: 22674,
      ft: '开启人脸识别按钮',
      r: '酷狗音乐开放平台'
    })
    utilService.Cookie.remove("kg_faceid", "/", "kugou.com");
    localStorage.removeItem("kg_faceid");
    toFaceAuth = true;
    faceAuth(()=>{
      checkInfo(()=>{
        setOpenRecognite(1+Math.random()*10)
      })
    })
  }

  useEffect(() => {
    let info = props.match.params.info
    if (info) {
      let _info = window.decodeURIComponent(info).replace('"{','{').replace('}"','}')
      let realInfo = JSON.parse(_info)
      setName(realInfo.name);
      setIdNum(realInfo.num);
      setReqId(realInfo.reqId);
      setSingerId(realInfo.singerId)
      setSingerSource(realInfo.singerSource)
      if(realInfo.faceAuthBack){
        e.emit('loading', true)
        // 左上角退出
        LightMobileCall.mobileCall(710, { type: 0});
        setFaceAuthBack(realInfo.faceAuthBack)
      }
    }
    //安卓弹出键盘设置（270）http://doc.kugou.net/showdoc-master/web/#/5?page_id=578
    LightMobileCall.mobileCall(270, {type: 1});

    function faceAuthBackFn(){
      let _cookie = utilService.Cookie.read("kg_faceid");
      let storage = localStorage.getItem("kg_faceid")
      //console.log(_cookie, 'cookie',document.cookie);
      console.log(storage,'storage');
      if(storage != null && storage){
        let cookie = JSON.parse(storage);
        if( cookie.status == 1 ){
          cookie.reqId ? bindConfirm( cookie.reqId ) : bindConfirm();
        }else{
          window.$Msg( decodeURIComponent(cookie.errorMsg) || '认证失败')
        }
        toFaceAuth = false;
        utilService.Cookie.remove("kg_faceid", "/", "kugou.com");
        localStorage.removeItem("kg_faceid");
      }/* else{
        window.$Msg('认证失败，请重新认证~')
      } */
    }

    LightMobileCall.KgWebMobileCall("KgWebMobileCall.pageStatusNew", function(res){
      //console.log(res, 'KgWebMobileCall.pageStatusNew');
      res = typeof(res) == 'string' ? JSON.parse(res) : res;
      if(res.status == 3/*  && toFaceAuth */){
        faceAuthBackFn()
      }
    })

    e.on("face_auth_back", ()=>{
      console.log('实名结果回来 换绑');
      //人脸识别重新返回页面
      faceAuthBackFn();
    })
  }, [])

  useEffect(() => {
    let _param = {
      faceAuthBack: true,
      name: name,
      num: idNum,
      reqId: reqId,
      singerId: singerId,
      singerSource: singerSource
    }
    let url = encodeURIComponent(curUrl+'?ChangeAccountInput='+window.encodeURIComponent(JSON.stringify(_param)));
    setJumpUrl(url);
  }, [name, idNum, reqId, singerId, singerSource])

  return (<div className="ChangeAccountInput">
    {!faceAuthBack ? <Fragment>
      <p className="faceR-title">当前业务需要人脸识别验证</p>
      <div className="faceR-icon"></div>
      <input className="faceR-input" value={idNum} type="text" placeholder="点击输入身份证号码" onChange={e=>{setIdNum(e.target.value);}}/>
      <input className="faceR-input" value={name} type="text" placeholder="点击输入真实姓名" onChange={e=>{setName(e.target.value);}}/>
      <div className="page-btn">
        <Button text="开启人脸认证" fn={recognite} />
      </div>
    </Fragment> : <Fragment></Fragment>}
    <Dialog title="提示" visible={showTipsDialog} setVisible={setShowTipsDialog} btns={btnFn} hideClose={hideClose}>
      <div className="centerText" dangerouslySetInnerHTML={{ __html: tipsContent }}></div>
    </Dialog>
    <FaceRecognition 
    name={name} 
    idNum={idNum}
    jumpUrl={jumpUrl}  
    openRecognite={openRecognite}  
    reqId={reqId} 
    faceAuthBack={faceAuthBack}
    showTips={showTips} 
    setShowTipsDialog={setShowTipsDialog}
    ></FaceRecognition>
  </div>)
} 